import { render, staticRenderFns } from "./LinearProgressBar.vue?vue&type=template&id=4c24d72c&lang=pug"
import script from "./LinearProgressBar.vue?vue&type=script&lang=js"
export * from "./LinearProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports